<template>
    <div>
        <auth-layout from="oauth">
            <slot></slot>
            <vue-recaptcha v-if="service && !token && isTokenChecked && isCaptchaEnabled"
                ref="recaptcha" @verify="onCaptchaVerified"
                size="invisible" sitekey="6LcMe7IrAAAAANoOlSMkWztH9_KFU5Ofj7jUK7n7"
            />
            <div class="row vh-100 overflow-x-hidden">
                <div class="col-12 bg-white rounded-lg mr-0 mr-md-minus-5px z-index-1 shadow">
                    <div class="d-flex align-items-start flex-column h-100">
                        <div class="my-auto w-100">
                            <div class="row justify-content-center">
                                <div class="col-10 col-sm-7 col-md-5 col-lg-8 col-xl-7 col-xxl-6 login-wrapper py-5">
                                    <div class="mx-auto login-w-limit">
                                        <div class="logo-wrapper text-center mb-2 mb-lg-5 pb-2">
                                            <img :src="$store.getters['dashboard/getImage']('logo.png')" height="125"/>
                                        </div>
                                        <div class="fadeIn">
                                            <login v-if="service && !token && isTokenChecked" ref="login" @captcha="onCaptcha" @loggedIn="getToken" :is-captcha-enabled="isCaptchaEnabled" from="oauth"></login>
                                            <b-alert v-else-if="!service && errors" variant="danger" show>
                                                <li v-for="error in errors">
                                                    {{ error[0] }}
                                                </li>
                                            </b-alert>
                                            <confirm-view v-else-if="service && token" :service="service"></confirm-view>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <language-switch/>
                    </div>
                </div>
            </div>
        </auth-layout>
    </div>
</template>

<script>
import Base from '@/plugins/Base'
import OAuthService from '@/services/OAuthService'
import AuthLayout from '@/layouts/AuthLayout'
import LanguageSwitch from '@/modules/auth/pages/LanguageSwitch'
import ConfirmView from './Confirmation'
import {ValidationObserver, ValidationProvider} from 'vee-validate'
import { VueRecaptcha } from 'vue-recaptcha'
import qs from 'qs'
import Login from "@/modules/auth/pages/Login.vue";

export default {
    components: {
        Login,
        AuthLayout,
        LanguageSwitch,
        ConfirmView,
        ValidationProvider,
        ValidationObserver,
        VueRecaptcha
    },
    metaInfo() {
        return {
            title: this.$t('login')
        }
    },
    data() {
        return {
            token: null,
            isTokenChecked: false,
            service: null,
            errors: null,
            isCaptchaEnabled: false
        }
    },
    watch: {
        timerEnabled(value) {
            if (value) {
                setTimeout(() => {
                    this.timerCount--
                }, 1000)
            }
        },
        timerCount: {
            handler(value) {
                if (value > 0 && this.timerEnabled) {
                    setTimeout(() => {
                        this.timerCount--
                    }, 1000)
                }
                else if (value > 0 && !this.timerEnabled) {
                    this.alertShow = false
                }
                else {
                    this.alertVariant = 'danger'
                    this.alertShow = true
                }
            },
            immediate: true
        }
    },
    created() {
        this.getService()
        if(process.env.VUE_APP_DISABLE_CAPTCHA_FOR_IPS){
          let ips = process.env.VUE_APP_DISABLE_CAPTCHA_FOR_IPS.split(',');
          fetch("https://api.ipify.org?format=json")
              .then(response => response.json())
              .then(data => {
                if(!ips.includes(data.ip)){
                  this.isCaptchaEnabled=true;
                }
              });
        }
        else if(process.env.VUE_APP_DISABLE_CAPTCHA!=='1'){
          this.isCaptchaEnabled=true;
        }
    },
    methods: {
        getService(){
            const config = {
                params: {
                    client_id: this.$route?.query?.client_id,
                    redirect_uri: this.$route?.query?.redirect_uri
                },
                paramsSerializer: (params) => qs.stringify(params, {encode: false})
            }

            OAuthService.getAuthorizeForm(config)
                .then(response => {
                    this.service = response.data.data
                    this.getToken()
                })
                .catch(error => {
                    if (error.status == 422) {
                        this.errors = error.data.errors
                    }
                })
        },
        onCaptcha() {
            this.$refs.recaptcha.execute()
        },
        onCaptchaVerified (recaptchaToken) {
            this.$refs.login.onCaptchaVerified(recaptchaToken)
            this.$refs.recaptcha.reset()
        },
        getToken() {
            let tokenExpiresIn = Base.LocalStorage.get('access_token_expires_in')
            let date = new Date();
            let tmpToken = Base.LocalStorage.get('access_token')
            if(date.getTime() > tokenExpiresIn){
                tmpToken=null;
            }
            this.token = tmpToken
            this.isTokenChecked=true
        }
    }
}
</script>
